import { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import ContentDesktop from './ContentDesktop/ContentDesktop';
import ContentMobile from './ContentMobile/ContentMobile';
import { UPLOAD_VIDEO } from '../../../../../constants/actionTypes';

const mapStateToProps = (state) => {
    return {
        upload: state.common.upload
    };
};
const mapDispatchToProps = (dispatch) => ({
    onUploadVideo: (payload) => dispatch({ type: UPLOAD_VIDEO, payload })
});

const EditVideoContent = (props) => {
    const { t } = useTranslation();
    const [trailerFile, setTrailerFile] = useState(null);
    const [trailerFileType, setTrailerFileType] = useState(null);
    const [fileUploadError, setFileUploadError] = useState('');

    const deleteTrailer = () => {
        setTrailerFile(null);
        setTrailerFileType(null);
    };

    useEffect(() => {
        if (trailerFile && trailerFile?.name) {
            setTrailerFileType(trailerFile.name.toLowerCase().split('.').pop());
        }
    }, [trailerFile]);

    useEffect(() => {
        if (trailerFileType) {
            props.onUploadVideo({
                file: trailerFile,
                type: trailerFileType,
                jobId: props.jobId,
                trailer: true
            });
        }
    }, [trailerFileType]);

    const handleVideoUpload = async (event, type) => {
        setFileUploadError('');
        const allowedVideoExtensions = ['mp4', 'mov', 'avi', 'mkv', 'flv', 'wmv', 'webm'];

        const file = event?.target?.files[0];
        const fileExtension = file?.name.split('.').pop().toLowerCase();
        if (!allowedVideoExtensions.includes(fileExtension)) {
            toast.error(t('PleaseUploadVideo'));
            return;
        }
        if (type === 'trailer') {
            setTrailerFile(event.target.files[0]);
        }
    };
    return (
        <>
            {isMobile ? (
                <ContentMobile
                    showLoader={props.showLoader}
                    jobId={props.jobId}
                    event={props.event}
                    handleVideoUpload={handleVideoUpload}
                    fileUploadError={fileUploadError}
                    trailerFile={trailerFile}
                    deleteTrailer={deleteTrailer}
                    thumbnail={props.thumbnail}
                    imagePreview={props.imagePreview}
                    handleImageChange={props.handleImageChange}
                />
            ) : (
                <ContentDesktop
                    showLoader={props.showLoader}
                    jobId={props.jobId}
                    event={props.event}
                    handleVideoUpload={handleVideoUpload}
                    fileUploadError={fileUploadError}
                    trailerFile={trailerFile}
                    deleteTrailer={deleteTrailer}
                    thumbnail={props.thumbnail}
                    imagePreview={props.imagePreview}
                    handleImageChange={props.handleImageChange}
                />
            )}
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(EditVideoContent);
